import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export type SideBarMenuItemProps = {
  icon: IconDefinition
  label?: string
  toggled: boolean
  disableLabel?: string
  onClick: () => void
}

export const SideBarMenuItem = ({
  icon,
  label,
  toggled,
  disableLabel,
  onClick,
}: SideBarMenuItemProps) => {
  const inactiveColor = disableLabel
    ? 'var(--palette-blue-300)'
    : 'var(--palette-white)'
  return (
    <Row
      gap="0.25rem"
      onClick={disableLabel ? null : onClick}
      style={{
        padding: '0.25rem 0.5rem',
        alignItems: 'center',
        borderRadius: '0.625rem',
        backgroundColor: toggled ? 'var(--palette-white)' : 'transparent',
        cursor: disableLabel ? 'not-allowed' : 'pointer',
        userSelect: 'none',
        height: !label ? '2.25rem' : 'auto',
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        fontSize={'1rem'}
        color={toggled ? 'var(--brand-secondary)' : inactiveColor}
      />
      {label && (
        <Text.Medium
          color={toggled ? 'var(--brand-secondary)' : inactiveColor}
          style={{
            fontSize: '1rem',
          }}
        >
          {label}
        </Text.Medium>
      )}
    </Row>
  )
}
